






















































































































import { Component, mixins } from 'nuxt-property-decorator';

import { usePerformanceCustomAppearence } from '@/composables/performance-custom-appearence';
import { PageContentMixin } from '@/composables/page-content';

import { ScenkonstOtPerformanceContentDataFragment } from '@/graphql/generated';
import { ComposableMixin } from '@/mixins/composable';
import { GraphQLImageMixin } from '@/mixins/graphql-image';

@Component
export default class ShowsPage extends mixins(
  PageContentMixin<ScenkonstOtPerformanceContentDataFragment>(),
  GraphQLImageMixin(),
  ComposableMixin(usePerformanceCustomAppearence),
) {
  /* eslint-disable max-len */
  get page () {
    return {
      title: this.pageContent.title,
      slug: '',
    };
  }

  get dynamicBlockContainers () {
    return this.pageContent.dynamicBlockContainers.filter(c => c.blocks.length > 0);
  }

  get facts () {
    const list: {
      label: string,
      value: string | null,
      placeholder: string
    }[] = [];

    if (this.pageContent.factBoxes)
      this.pageContent.factBoxes.forEach((factBox) => {
        list.push({
          label: factBox.title,
          value: factBox.text,
          placeholder: '',
        });
      });

    return list;
  }

  get archivedDisclaimer () {
    if (!this.pageContent.archived)
      return null;

    return {
      title: 'Konsertens datum har passerat',
      lead: 'Denna sida är en del av vårt arkiv.',
    };
  }
}
